// extracted by mini-css-extract-plugin
module.exports = {"wrap":"loading_wrap__1lHUe","center":"loading_center__2PQWi","loading":"loading_loading__3nYZo"};